import {
  useShowContext,
  Labeled,
  FunctionField,
  useList,
  ListContextProvider,
  Datagrid,
  TextField,
} from "react-admin";
import { Box, Rating } from "@mui/material";
import { referenceStatusList } from "../utils";

const ReferencesReviewsField = () => {
  const { record } = useShowContext();
  const references = record.references;

  const referencesListContext = useList({
    data: references ?? [],
    resource: "Provider",
  });

  return (
    <Labeled sx={{ width: "100%" }} label="References">
      <ListContextProvider value={referencesListContext}>
        <Datagrid
          bulkActionButtons={false}
          sx={{ "& thead": { display: "none" } }}
          rowSx={(_, index) => ({
            td: { padding: index > 0 ? "8px 0" : "0 0 8px" },
          })}
          rowClick={false}
        >
          <Box
            sx={{
              display: "grid",
              gap: "8px 32px",
              gridTemplateColumns: "auto auto auto auto auto 1fr auto",
            }}
          >
            <Labeled label="Customer ID">
              <TextField source="clientId" />
            </Labeled>

            <Labeled label="Reference Name">
              <TextField source="name" link="show" />
            </Labeled>

            <Labeled label="Added on">
              <FunctionField
                render={(value) =>
                  value["createdTimestamp"]
                    ? new Date(+value["createdTimestamp"]).toDateString()
                    : "-"
                }
              />
            </Labeled>

            <Labeled label="Status">
              <FunctionField
                render={(value) =>
                  value["status"]
                    ? referenceStatusList.find((s) => s.id === value["status"])
                        ?.name
                    : "-"
                }
              />
            </Labeled>

            <Labeled label="Email">
              <TextField source="email" link="show" />
            </Labeled>

            <Labeled label="Phone Number">
              <TextField source="phoneNumber" link="show" />
            </Labeled>

            <Labeled
              label="Rating"
              component="div"
              sx={{ gridColumn: "span 6" }}
            >
              <FunctionField
                render={(value) => (
                  <Box
                    sx={{ width: 200, display: "flex", alignItems: "center" }}
                  >
                    <Rating
                      name="half-rating"
                      value={parseFloat(value.rating)}
                      precision={0.5}
                      readOnly
                    />
                    <Box sx={{ ml: 2 }}>{`${value.rating || "-"}/5`}</Box>
                  </Box>
                )}
              />
            </Labeled>
            <Labeled
              label="Review"
              component="div"
              sx={{ gridColumn: "span 6" }}
            >
              <FunctionField
                source="reviews.review"
                render={(value) => value.review}
              />
            </Labeled>
          </Box>
        </Datagrid>
      </ListContextProvider>
    </Labeled>
  );
};

export default ReferencesReviewsField;
